{
	"ok": "OK",
	"phone": "Telefoon",
	"update": "Bijwerken",
	"approve": "Goedkeuren",
	"reject": "Weigeren",
	"accepted": "Aanvaard",
	"pending": "In afwachting",
	"rejected": "Afgekeurd",
	"edit": "Bewerk",
	"cancel": "Annuleer",
	"send": "Verzenden",
	"create": "Aanmaken",
	"yes": "Ja",
	"no": "Neen",
	"save": "Opslaan",
	"home": "Home",
	"english": "Engels",
	"french": "Frans",
	"nederlands": "Nederlands",
	"takeaway": "afhalen",
	"delivery": "leveren",
	"asap": "zo snel mogelijk",
	"cash": "Cash",
	"pay_later": "Later betalen",
	"invoice": "Factuur",
	"BCMCMOLLIE": "Bancontact",
	"Visa/Mastercard": "Visa/Mastercard",
	"Monizze": "Maaltijdcheques (Monizze)",
	"venue_closed": "Momenteel is het niet mogelijk om bij deze zaak te bestellen.",
	"ordering_impossible": "Momenteel is het niet mogelijk om via {{ scenario }} bij deze zaak te bestellen.",
	"order_details_for_groups": "Leveringsdetails zullen door de groep eigenaar bepaald worden.",
	"complete_address": "Alvorens verder te gaan, gelieve je adres in te vullen",
	"naam": "Naam",
	"characters": "tekens",
	"save_address": "Adres opslaan",
	"private_shop": "U dient zich in te loggen of te registreren voordat u doorgaat. Als u probeert te bestellen in een restaurant met gelimiteerde toegang, zoals een bedrijfsrestaurant, gebruik dan het e-mailadres van uw bedrijf of het adres dat door de locatie is goedgekeurd.",
	"i_search": "Ik zoek",
	"back_to_checkout": "Het gekozen tijdstip en/of scenario is niet langer geldig. Gelieve de gegevens van je bestelling opnieuw na te kijken.",
	"opens_at": "opent om {{ hour }}u",
	"closes_at": "sluit om {{ hour }}u",
	"open": "open",
	"closed": "gesloten",
	"exceptionally_closed": "uitzonderlijk gesloten",
	"coming_soon": "binnenkort beschikbaar",
	"reorder_unavailable": "Deze bestelling kan niet opnieuw geplaatst worden. Mogelijk zijn een aantal producten uitverkocht.",
	"search_merchant": "Handelaar zoeken",
	"filters": "filters",
	"confirm": "bevestigen",
	"visible": "zichtbaar",
	"invisible": "onzichtbaar",
	"back": "terug",
	"total": "totaal",
	"request_account_deletion": {
		"title": "Aanvraag tot verwijdering account",
		"description": "Als je jouw account verwijdert, worden al je persoonlijke gegevens - inclusief opgeslagen adressen en bestelgeschiedenis - permanent uit ons systeem verwijderd.",
		"confirmation": "We vinden het jammer dat je ons verlaat. Houd er rekening mee dat het tot 24 uren kan duren voordat je account volledig is verwijderd.",
		"button":"Verwijder mijn account"	
	},

	"read_more": "lees meer",
	
	"kitchen_type": {
		"bakery":"bakkerij",
		"butcher":"slagerij / traiteur", 
		"camping":"camping / vakantiepark", 
		"cheese":"kaaswinkel", 
		"chip_shop":"frituur / snackbar", 
		"cocktails":"cocktails, ontbijtboxen en meer", 
		"event":"evenement / feestcatering", 
		"foodtruck":"foodtruck / marktkraam", 
		"icecream":"ijssalon", 
		"industrial":"industriële keuken", 
		"leisure":"vrije tijd / sport", 
		"petrol":"benzine", 
		"pizzeria":"pizzeria / pastabar", 
		"pub":"café", 
		"restaurant":"restaurant / brasserie", 
		"sandwich":"broodjesbar / lunchroom", 
		"supermarket":"supermarkt", 
		"sushi":"sushi-restaurant"
	},

"dish_type": {
	"alcoholic_drink": "alcoholische drank",
	"american_pizza": "amerikaanse pizza",
	"sandwiches": "broodjes",
	"burgers": "burgers",
	"curry": "curry",
	"desserts": "desserts",
	"durum": "durum",
	"fries": "friet",
	"fresh_drinks": "frisdranken",
	"soft_drinks": "frisdranken",
	"gourmet_burgers": "gourmet burgers",
	"halal": "halal",
	"home-made_burgers": "huisgemaakte burgers",
	"hotdogs": "hotdogs",
	"ice_cream": "ijs",
	"kapsalon": "kapsalon",
	"chicken": "kip",
	"cold_dishes": "koude gerechten",
	"limousine_burgers": "limousine burgers",
	"machine_guns": "mitrailetten",
	"noodles": "noodles",
	"breakfast": "ontbijt",
	"panini": "panini",
	"pasta": "pasta",
	"pita_kebab": "pita kebab",
	"pizza": "pizza",
	"poke_bowls": "poke bowls",
	"ribs": "ribs",
	"salads": "salades",
	"soups": "soep",
	"sushi": "sushi",
	"pies": "taart",
	"taco": "taco",
	"thai": "thai",
	"vegan": "vegan",
	"vegetarian": "vegetarisch",
	"meat": "vlees",
	"wine": "wijn",
	"wrap": "wrap"
},

	"filter_on": {
		"loyalty_points": "klantenkaart",
		"order_and_reward": "bestel & win",
		"open_today": "vandaag open",
		"favourite_merchants": "mijn favoriete zaken",
		"kitchen_type": "Op type keuken",
		"dish_type": "Op type gerecht/specialiteit",
		"reset": "filters verwijderen",
		"order_and_reward_info": "Elke zoveelste bestelling valt in de prijzen en krijgt een prijs (waardebon)."
	},

	"pos": {
		"pos": "ingave",
		"modules": "modules",
		"cancel_order": "bestelling annuleren",
		"orders": "bestellingen",
		"tabs": "rekeningen",
		"products": "producten",
		"coupons": "coupons",
		"journal": "dagboek",
		"customers": "klanten",
		"settings": "instellingen",
		"discount": "korting",
		"transfer": "transfer",
		"refund": "terugbetaling",
		"employee": "medewerkers",
		"log_out": "uitloggen",
		"reports": "rapportage",
		"kds": "kds",
		"archive": "Archiveer",
		"today": "Vandaag",
		"yesterday": "Gisteren",
		"previous_days": "Voorbije dagen",
		"next_days": "Volgende dagen",
		"current_month": "Huidige maand",
		"previous_month": "Vorige maand",
		"current_year": "Dit jaar",
		"custom": "Aangepast",
		"pick_a_date_range": "Kies een periode",
		"period": "Periode",
		"payment_brand": "Betaalmethode",
		"payment_state": "Betaalstatus",
		"scenario": "Scenario",
		"revenue": "Omzet",
		"product": "Product",
		"category": "Categorie",
		"price": "Prijs",
		"out_of_stock": "Uit voorraad",
		"not_visible_in_menu": "Niet zichtbaar in menu",
		"no_registry_link": "Geen kassa link",
		"no_tax_chosen": "Geen BTW gekozen",
		"visible": "Zichtbaar",
		"invisible": "Onzichtbaar",
		"technical_categories": "Technische categorieën",
		"venue": "venue",
		"scan_badge_title": "Gelieve een badge te scannen",
		"scan_badge_content": "Scan de badge waarop het credit gestort moet worden.",
		"try_again_title": "Oeps, er ging iets mis",
		"try_again_content": "Probeer het opnieuw.",
		"payment_succesful": "De betaling was succesvol",
		"deliveries": "leveringen",
		"add_reference_comment": "Voeg een referentie/commentaar toe",
		"please_add_reference_comment": "Gelieve een referentie of commentaar in te vullen",
		"confirmation_cancel_order": "Bent u zeker dat u deze bestelling wilt annuleren?",
		"group_summary": "Groepsoverzicht",
		"group_details": "Groepsdetails",
		"cash_payment": "Cash betaling",
		"price_order": "Prijs bestelling",
		"rounded_price_order": "Prijs bestelling (Afgerond)",
		"change": "Wisselgeld",
		"pay_later": "Later betalen",
		"confirm_payment": "Betaling bevestigen",
		"close": "Sluiten",
		"center_map_merchant": "Kaart centreren op de zaak",
		"tax_tariff": "BTW tarief",
		"label_archive": "Archief",
		"label_open": "Open",
		"preparing": "Wordt klaargemaakt",
		"ready": "Klaar",
		"location_unknown": "De locatie is momenteel nog onbekend",
		"print_order": "Afdrukken bestelling",
		"employees": "werknemers",
		"cancel_order_to_navigate_confirmation": "Als u de pagina verlaat, wordt de huidige bestelling geannuleerd. Bent u zeker dat u de pagina wilt verlaten?",
		"sent_to_registry": "Doorsturen naar kassa",
		"sent_all_orders_to_registry": "Alle bestellingen doorsturen naar kassa"
	},

	"pos_product": {
    "name_english": "naam (Engels)",
    "name_french": "naam (Frans)",
    "name_dutch": "naam (Nederlands)",
    "description_english": "Beschrijving (Engels)",
    "description_french": "Beschrijving (Frans)",
    "description_dutch": "Beschrijving (Nederlands)",
    "price": "Prijs",
		"unit": "Eenheid",
		"unit_person": "Persoon",
		"unit_slice": "Sneetje",
		"unit_piece": "Stuk",
		"unit_kg": "Kg",
		"unit_g": "g",
		"points": "Aantal punten",
		"taxons": "Categorieën",
		"allergens": "Allergenen",
		"template": "Sjabloon",
    "registry_item_id": "Kassa item ID",
    "is_available": "Is beschikbaar?",
    "can_be_bought_with_loyalty_points": "Kan met getrouwheidspunten gekocht worden?",
    "is_blueprint": "Is sjabloon?",
    "is_instant_checkout": "Is instant checkout?",
    "is_coupon": "Is coupon?",
		"image": "Afbeelding",
		"add_image": "Afbeelding toevoegen",
		"edit_image": "Afbeelding bewerken",
		"product_parts": "Product onderdelen",
		"add_product_part": "Onderdeel toevoegen",
		"is_removable": "Is verwijderbaar?",
		"influences_price": "Beïnvloedt prijs?",
		"name_product_part": "Naam onderdeel",
		"none": "Geen",
		"is_credit": "Is krediet?",
		"is_suggested": "Is aanbevolen?",
		"ean": "EAN code",
		"sku": "SKU code",
		"product_updated": "Product bijgewerkt",
		"product_updated_error": "Er ging iets mis, probeer het later opnieuw",
		"pick_new_color": "Kies een nieuwe kleur",
		"pick_used_color": "Of kies een kleur die al gebruikt werd",
		"product_settings": "Weergave instellingen",
		"product_tax_tariffs": "BTW-tarieven",
		"tax_tarriff": "BTW-tarief",
		"no_tax_tarriff": "Btw-tarief van de categorie",
		"create_new_product": "Nieuw product aanmaken",
		"product_created_succesfully": "Product succesvol aangemaakt",
		"product_created_error": "Er ging iets mis, probeer het later opnieuw",
		"confirm_delete_product": "Ben je zeker dat je dit product wil verwijderen?",
		"edit_product": "Product bewerken"
	},

	"pos_settings": {
		"image": "Productafbeeldingen verbergen of tonen",
		"logo": "logo",
		"sort": "Producten sorteren op naam of volgorde in de categorie",
		"theme":	"Licht of donker thema",
		"display": "Weergave",
		"overview_tax_tariffs": "Overzicht BTW-tarieven",
		"visibility": "Zichtbaarheid categorieën",
		"font_size": "Grootte lettertype",
		"font_size_preview": "Preview lettertype",
		"font_size_preview_text": "Dit is een voorbeeldtekst in ",
		"font_size_second_screen": "Grootte lettertype tweede scherm",
		"second_screen": "Activeer dit als u een tweede scherm aan de kassa hebt",
		"show_prices": "Toon prijzen op het ingave en teruggave scherm",
		"show_prices_consumer_screen": "Toon prijzen op het consumenten scherm",
		"coupons": "coupons",
		"kiosk": "Kiosk instellingen",
		"printer": "Printer instellingen",
		"comment_enabled": "Mogelijkheid om commentaar toe te voegen",
		"comment_required": "Commentaar verplicht",
		"reference_enabled": "Mogelijkheid om referentie toe te voegen",
		"reference_required": "Referentie verplicht",
		"true": "Ja",
		"false": "Nee",
		"number_reservation": "Nummerreservering",
		"order_started": "bij starten van bestelling",
		"order_finished": "bij afronden van bestelling",
		"payment_method_top_or_bottom": "Betalingsmethode bovenaan of onderaan de pagina",
		"pm_on_top_true": "Bovenaan de pagina",
		"pm_on_top_false": "Onderaan de pagina",
		"pm_on_top_undefined": "Nog niet bepaald",
		"takeway_location": "Afhaallocatie",
		"mode": "Mode",
		"mode_kiosk": "Bestel op de kiosk",
		"mode_counter": "Ontvang een nummer en bestel aan de toog",
		"buzzers_enabled": "Buzzers gebruiken",
		"buzzers_required": "Buzzers verplicht",
		"create_kiosk": "Nieuwe kiosk toevoegen",
		"edit_kiosk": "Kiosk bewerken",
		"delete_kiosk": "Kiosk verwijderen",
		"delete_kiosk_confirmation": "Ben je zeker dat je deze kiosk wil verwijderen?",
		"kiosk_created_succesfully": "Kiosk werd succesvol aangemaakt",
		"kiosk_updated_succesfully": "Kiosk werd succesvol bijgewerkt",
		"kiosk_deleted_succesfully": "Kiosk werd succesvol verwijderd",
		"kiosk_updated_error": "Er ging iets mis, probeer het later opnieuw",
		"print_automatic": "Automatisch printen",
		"number_of_copies": "Aantal kopieën",
		"print_tabs": "Print tabs",
		"name": "Naam",
		"mac_address": "MAC adres",
		"email": "E-mail",
		"number_leading_whitespaces": "Aantal witregels vooraan",
		"scenario": "Scenario",
		"sent_at": "Tijdstip bestelling",
		"dist_timing_target": "Geschatte levertijdstip",
		"order_location": "Bestellocatie",
		"dist_location": "Leveringslocatie",
		"qr": "QR code",
		"categories": "Categorie titels",
		"total": "Totaalbedrag bestelling",
		"reference": "Klantreferentie",
		"user_phone": "Klant GSM",
		"user_email": "Klant e-mail",
		"code": "Ordernummer",
		"subtotal": "Subtotaal",
		"ticket_message": "Bericht",
		"no_of_persons": "Aantal personen",
		"payment": "Betalingsstatus",
		"comment": "Commentaar",
		"level_of_activity": "Activiteitsniveau",
		"message": "Bericht",
		"number_trailing_whitespaces": "Aantal witregels achteraan",
		"dist_location_id": "Afleverlocatie",
		"cashdrawer_location_id": "Kassalade locatie",
		"order_location_id": "Bestellocatie",
		"order_location_types": "Bestellocatie types",
		"kiosk_id": "Kiosk",
		"barcode_sku": "Barcode SKU",
		"barcode_ean": "Barcode EAN",
		"kiosk_number": "Kiosk nummer",
		"order_dist_timing_target_footer": "Richttijd onderaan ticket",
		"product_registry_id": "Product kassa ID",
		"show_prices_printer": "Prijzen",
		"amount_of_products": "Aantal producten",
		"order_scenario_large": "Bestellocatie & Scenario bovenaan ticket",
		"none": "n.v.t.",
		"ticket_content": "Ticket inhoud",
		"ticket_settings": "Ticket instellingen",
		"ticket_settings_description": "Kies hoe bestellingen in tickets worden ingedeeld",
		"one_ticket_per_order": "1 ticket per bestelling",
		"one_ticket_per_product": "1 ticket per product",
		"report": "X/Z rapporten",
		"vat": "BTW tickets",
		"delete_printer_confirmation": "Ben je zeker dat je deze printer wil verwijderen?",
		"printer_created_successful": "Printer succesvol aangemaakt",
		"printer_created_error": "Er ging iets mis, probeer het later opnieuw",
		"printer_saved_succesfully": "Printer succesvol bijgewerkt",
		"printer_saved_error": "Er ging iets mis, probeer het later opnieuw",
		"printer_deleted_succesfully": "Printer succesvol verwijderd",
		"printer_deleted_error": "Er ging iets mis, probeer het later opnieuw",
		"delete_printer": "Printer verwijderen",
		"add_printer": "Printer toevoegen",
		"refresh_printers": "Vernieuwen",
		"add_new_printer": "Nieuwe printer toevoegen",
		"print_on_state": "Printen bij status"
	},
	"pos_reports": {
		"starts_at": "Start op",
		"ends_at": "Eindigt op",
		"first_ticket_at": "Eerste ticket op",
		"location_name": "Locatie",
		"user": "Gebruiker",
		"revenue_total_gross": "Bruto omzet",
		"net_revenue": "Netto omzet",
		"report_type": "Type",
		"print": "Afdrukken",
		"x_reports": "Toon X-rapporten",
		"z_reports": "Toon Z-rapporten",
		"daily_closing": "Dagafsluiting",
		"fdm_date": "Datum",
		"fdm_time": "Tijdstip",
		"label": "Label",
		"order_id": "Bestelling ID",
		"ticket_number": "Ticketnummer",
		"ejournal_number": "Nummer elektronisch journaal",
		"user_insz": "INSZ",
		"report_number": "Nr",
		"electronic_journal": "Elektronisch journaal",
		"xz_reports": "X/Z rapporten",
		"statistics": "Statistieken",
		"fdm_production_number": "Productienummer FDM",
		"plu_hash": "PLU hash",
		"pos_version": "Kassa versie",
		"signature": "Handtekening",
		"vsc_id": "VSC ID",
		"vsc_ticket_counter": "VSC ticket teller",
		"vsc_total_counter": "VSC totaal teller",
		"export": "Exporteren naar CSV",
		"start_shift": "Start shift",
		"end_shift": "Einde shift",
		"product_name": "Productnaam",
		"vat_tariff": "BTW tarief",
		"undefined": "Niet gedefinieerd",
		"close_report_confirmation": "Ben je zeker dat je dit rapport wil afsluiten?",
		"daily_totals": "Dagtotalen",
		"download_reports": "Download rapporten",
		"category": "Categorie",
		"product": "Product",
		"avg_revenue": "Gemiddelde omzet",
		"grouping": "Groepering",
		"hour": "Uur",
		"day": "Dag",
		"week": "Week",
		"month": "Maand",
		"year": "Jaar",
		"general": "Algemeen"
	},
	"pos_registry": {
		"registry_settings": "Kassa instellingen",
		"state": "Status",
		"data_from_registry": "Data uit kassa",
		"id": "ID",
		"synced_products": "Gesynchroniseerde producten",
		"tables": "Tafels",
		"unsynced_products": "Niet gesynchroniseerde producten",
		"product_with_wrong_registry_id": "Producten met kassa ID die niet of foutief in kassa voorkomen",
		"unsynced_orders": "Niet gesynchroniseerde bestellingen"
	},
	"fdm": {
		"pay_attention": "Opgelet",
		"fdm_warning_message": "De FDM moet correct aangesloten en verbonden zijn en de ingelogde gebruiker moet een geldig INSZ-nummer hebben voordat u een bestelling kan ingeven.",
		"to_gks_page": "Naar de gks-pagina",
		"started_shift": "Shift gestart",
		"ended_shift": "Shift beëindigd",
		"date": "Datum",
		"transactions": "Transacties",
		"gks_title": "Geregistreerd Kassa Systeem (GKS)",
		"reset": "Reset",
		"connect_with_fdm": "Connecteren met FDM",
		"identification": "Identificatie",
		"statistics": "Statistieken",
		"request": "Opvragen",
		"errors": "Foutmeldingen",
		"pincode": "Pincode",
		"send_pincode": "Pincode verzenden"
	},	
	"pos_custom_price": {
		"title": "Voer de aangepaste prijs in voor dit product",
		"original_label": "Originele prijs",
		"label": "Aangepaste prijs",
		"100_discount": "100% korting",
		"50_discount": "50% korting",
		"comment": "Opmerking"
	},

	"kiosk": {
		"cancel_order": "Bestelling annuleren",
		"modify_order": "Bestelling aanpassen",
		"order_here": "Bestel op deze kiosk",
		"pay_cashier": "Betaal aan de kassa",
		"pay_cashier_or_kiosk": "Betaal je bestelling aan de kassa of via",
		"cancel_payment": "Betaling annuleren",
		"order_at_counter": "Wens je te bestellen aan de toog?",
		"click_for_number": "KLIK HIER en je ontvangt een nummertje. Wanneer het jouw beurt is, wordt je bestelling opgenomen.",
		"session_timeout_title": "Je sessie is bijna verlopen.",
		"session_timeout_content": "Je hebt al een tijdje niets meer veranderd aan je bestelling. De kiosk gaat terug naar de startpagina binnen ",
		"session_timeout_button": "Ik wil mijn bestelling nog verderzetten",
		"buzzer_number": "Buzzernummer"
	},
	"basketbar": {
		"details": "details",
		"show_menu": "Bekijk menu",
		"view_order": "Bestelling bekijken",
		"complete_order": "Bestelling afronden",
		"back": "Terug",
		"confirm_order": "Bestelling bevestigen",
		"finalize_order": "Finaliseer bestelling",
		"pay_order": "Bestelling betalen",
		"terminal_error": "De betaalterminal is momenteel niet beschikbaar",
		"wallet_error": "De betaling via wallet kan momenteel niet voltooid worden.",
		"catering_location_missing": "Gelieve een catering locatie op te geven",
		"name_missing": "Gelieve een naam op te geven",
		"monizze_balance_insufficient": "Saldo op de maaltijdchequekaart ontoereikend.",
		"wallet_balance_insufficient": "Saldo in wallet is ontoereikend.",
		"comment_required_1": "Gelieve ",
		"comment_required_2": " in te vullen. ",
		"buzzer_number_missing": "Gelieve een buzzernummer op te geven",
		"start_order": "Start bestelling"
	},
	"weekdays": {
		"mon":"maa",
		"tue":"din",
		"wed":"woe",
		"thu":"don",
		"fri":"vrij",
		"sat":"zat",
		"sun":"zon"
	},			
	"main": {
		"log_in": "Inloggen",
		"guest": "Doorgaan als gast",
		"register": "Registreer hier",
		"register_message": "Nog geen account? ",
		"register_benefits1": " Snel en makkelijk bestellen",
		"register_benefits2": " Persoonlijke aanbiedingen",
		"register_benefits3": " Herhaal vorige bestellingen",
		"register_benefits4": " ...",
		"welcome": "Welkom",
		"order_type": "Kies je soort bestelling",
		"qr_begin": "Heb je een QR code? ",
		"qr_end": "Scan deze dan hier!",
		"product": "De producten"
	},
	"navigation": {
		"welcome": "Welkom",
		"home": "Home",
		"menu": "Menu",
		"profile": "Mijn profiel",
		"log_in": "Inloggen",
		"log_out": "Log uit",
		"register": "Registreer",
		"language": "Taal",
		"apply": "Vraag goedkeuring",
		"about_us": "Over ons",
		"contact": "Contacteer",
		"my_orders": "Mijn bestellingen",
		"my_groups": "Mijn bestelgroepen",
		"privacy_policy": "Privacy statement",
		"terms_and_conditions": "algemene voorwaarden",
		"my_favourite_merchants": "Mijn favoriete zaken",
		"loyalty_points": "Mijn klantenkaarten",
		"deliveries": "Leveringen"
	},
	"loyalty_points": {
		"none_saved": "U hebt nog geen punten gespaard",
		"click_for_info": "Klik op je klantenkaart om historiek van transacties te bekijken.",
		"latest_changes": "Laatste wijzigingen",
		"earn_one": "Deze bestelling levert je {{ loyalty_points }} getrouwheidspunt op!",
		"earn_multiple": "Deze bestelling levert je {{ loyalty_points }} getrouwheidspunten op!",
		"use_1": "1 getrouwheidspunt verzilveren",
		"use_multiple": "{{ loyalty_points }} getrouwheidspunten verzilveren",
		"title": "Ik gebruik mijn getrouwheidspunten voor dit product",
		"you_save": "Je spaart",
		"you_use": "Je gebruikt"
	},
	"apply": {
		"title": "Vraag goedkeuring voor jou groep",
		"submit": "Vraag goedkeuring",
		"group_name": "Groepsnaam",
		"group_description": "Groepsbeschrijving",
		"zip_code": "Postcode",
		"company_name": "Bedrijfsnaam",
		"vat": "BTW nummer",
		"number_of_users": "Geschatte aantal gebruikers",
		"remarks": "Opmerkingen",
		"address_line_1": "Adres 1",
		"address_line_2": "Adres 2",
		"city": "Plaats",
		"country": "Land",
		"applied": "De status van uw aanvraag",
		"applied_description": "Uw aanvraag voor goedkeuring van groep {{group_name}} is nog niet goedgekeurd.",
		"approved": "Goedgekeurd",
		"approved_description": "Uw aanvraag voor goedkeuring van groep {{group_name}} is goedgekeurd.",
		"submitted": "Uw groep is ingediend ter goedkeuring",
		"payment_methods": "Betaalmethodes",
		"instant_checkout": "Instant checkout",
		"checkout_at": "Finalisatie om",
		"who_pays": "Bestelling betaald door",
		"owner": "Groepsbeheerder",
		"user": "Gebruiker",
		"merchant": "Handelaar",
		"qr_code": "QR code",
		"generate_qr_code": "Genereer nieuwe QR code",
		"qr_confirmation_message": "Weet je zeker dat je een nieuwe QR code wil genereren? De oude QR code zal niet meer werken."

	},
	"forgot_password": {
		"question": "Je wachtwoord vergeten?",
		"check_emails": "Gelieve je emails te controleren",
		"check_emails_description": "Gelieve op de link te klikken in de email die we zonet stuurden naar {{ email }} om je wachtwoord opnieuw in te stellen. Indien je geen email hebt ontvangen, controleer dan aub het opgegeven emailadres en voer het zonodig opnieuw in.",
		"reset": "Stel wachtwoord opnieuw in",
		"not_found": "Email adres niet gevonden"
	},
	"user": {
		"login": "Inloggen",
		"login_badge": "Gelieve uw badge te scannen\nom te bestellen op deze kiosk",
		"use_credentials": "Liever inloggen met emailadres en wachtwoord?",
		"use_badge": "Liever inloggen met badge?",
		"email": "E-mail",
		"password": "Wachtwoord",
		"credentials_mismatch": "Uw e-mailadres of wachtwoord is onjuist",
		"first_name": "Voornaam",
		"last_name": "Achternaam",
		"incorrect_phone": "Onjuist telefoonnummer",
		"confirm_password": "Bevestig wachtwoord",
		"password_match": "De wachtwoorden komen niet overeen",
		"register": "Registreren",
		"register_success": "Je bent succesvol geregistreerd",
		"register_error": "Er is een fout opgetreden tijdens de registratie",
		"login_error": "Er is een fout opgetreden tijdens het inloggen",
		"mobile": "Mobiel telefoonnummer",
		"existing_account": "Ik heb een account",
		"guest_login": "Doorgaan als gast",
		"forget_password": "Wachtwoord vergeten?",
		"privacy_check_1": "Door dit selectievakje aan te vinken, ga je akkoord met onze",
		"privacy_check_2": "en ons",
		"privacy_check_3": "",
		"privacy_check_general_terms": "algemene voorwaarden",
		"privacy_check_privacy_statement": "privacy statement",
		"insz_number": "INSZ-nummer",
		"insz_invalid": "Uw INSZ-nummer is ongeldig, waardoor deze functie niet beschikbaar is."
	},
	"country": {
		"Belgium": "België",
		"France": "Frankrijk"
	},
	"group_invitations": {
		"title": "Groepsuitnodigingen",
		"accept": "Accepteer",
		"refuse": "Weiger",
		"refused_success": "U hebt de groepsuitnodiging geweigerd",
		"refused_error": "Er is een fout opgetreden bij het weigeren van de uitnodiging"
	},
	"profile": {
		"title": "Mijn profiel",
		"my_personal_information": "Mijn persoonlijke gegevens",
		"my_email_addresses": "Mijn e-mailadressen",
		"my_groups": "Groepen die ik beheer",
		"my_group_memberships": "Groepen waar ik lid van ben",
		"groups_for_my_shop": "Goedgekeurde groepen",
		"members": "Leden",
		"leave": "Verlaten",
		"choose_language": "Kies taal",
		"login_success": "Je bent succesvol ingelogd",
		"normal_orders": "Mijn bestellingen",
		"suborders": "Mijn deelbestellingen",
		"group_orders": "Mijn groepsbestellingen",
		"remove_suborders": "Verwijder alle deelbestellingen",
		"remove_suborders_confirm": "Bent u zeker dat u alle deelbestellingen wilt verwijderen?",
		"suborders_delete_error": "Er is een fout opgetreden bij het verwijderen van alle deelbestellingen",
		"updated_success": "Uw profiel is bijgewerkt",
		"updated_error": "Er is een fout opgetreden bij het bijwerken van je profiel",
		"confirm_group_delete": "Weet je zeker dat je deze groep wilt verwijderen?",
		"group_updated_success": "Groep is succesvol bijgewerkt",
		"group_updated_error": "Er is een fout opgetreden bij het bijwerken van de groep",
		"group_name_updated": "Groepsnaam is succesvol bijgewerkt",
		"group_name_update_error": "Er is een fout opgetreden bij het bijwerken van de groepsnaam",
		"group_deleted_success": "Groep is succesvol verwijderd",
		"group_deleted_error": "Groep kan niet worden verwijderd",
		"confirm_leave_group": "Weet u zeker dat u deze groep wilt verlaten?",
		"group_left_success": "U hebt de groep succesvol verlaten",
		"group_left_error": "Er is een fout opgetreden bij het verlaten van deze groep",
		"prefrences_update_success": "Voorkeuren succesvol bijgewerkt",
		"preferences_update_error": "Er is een fout opgetreden bij het bijwerken van voorkeuren",
		"group_status_update_error": "Er is een fout opgetreden bij het bijwerken van de groepsstatus"
	},
	"order": {
		"number":"Nummer",
		"registry":"Kassakoppeling",
		"device_type":"Type Apparaat",
		"transaction_id":"Transactie",
		"review": "In beoordeling",
		"composing":"Wordt bewerkt",
		"sent": "Verzonden",
		"received": "Ontvangen",
		"printed": "Geprint",
		"preparing": "Wordt klaargemaakt",
		"prepared": "Klaargemaakt",
		"distributing": "Onderweg",
		"distributed": "Gedistribueerd",
		"canceled": "Geannuleerd",
		"summary": "Overzicht bestelling",
		"remark": "Opmerking",
		"add_remark": "Opmerking toevoegen",
		"payment_method_selection": "Selecteer betaalmethode:",
		"payment_method": "betaalmethode",
		"delete_suborder_error": "Er is een fout opgetreden bij het verwijderen van de deelbestelling",
		"total_products": "Totaal producten",
		"total_order": "Totale bestelling",
		"scenario": "Selecteer afleveringsmethode:",
		"send": "Verzend bestelling",
		"show_details":"Bekijk details bestelling",
		"hide_details":"Verberg details bestelling",
		"reorder":"Opnieuw bestellen",
		"merchant_name":"Naam zaak",
		"delivery_time":"Aflevertijdstip",
		"amount":"Bedrag",
		"order_type":"Type bestelling",
		"status":"Status",
		"delivery_address":"Afleveradres",
		"name":"Naam",
		"user_email":"Email",
		"user_phone":"GSM",
		"unlock_code": "Ontgrendelcode",
		"kiosk_confirmation": "Je bestelling wordt door ons verwerkt!\n",
		"kiosk_confirmation_with_printer": "Neem het ticketje uit de printer.\n",
		"kiosk_confirmation_with_cash": "We houden je op de hoogte.\n",
		"modified": "Aangepast",
		"not_yet_sent_to_registry": "De bestelling werd nog niet doorgestuurd naar de kassa"
	},
	"order_notif": {
		"order_distributing_1": "Je bestelling bij {{ merchant_name }} is onderweg en zal",
		"order_distributing_2": " binnen {{ duration }} minuten geleverd worden",
		"order_distributing_no_location": "Je bestelling bij {{ merchant_name }} is onderweg.",
		"order_distributed": "Je bestelling werd afgeleverd. Smakelijk!",
		"order_prepared": "Je bestelling bij {{ merchant_name }} is klaar om opgehaald te worden.",
		"order_distributed_vending_machine": "Je bestelling werd opgehaald. Smakelijk!",
		"unlock_code": "Je ontgrendelcode is"
	},
	"my-orders": {
		"cancel_order": "Order annuleren",
		"suborder_cancelled_success": "De deelbestelling is succesvol geannuleerd",
		"all_suborders_deleted": "Alle deelbestellingen van deze groep zijn succesvol verwijderd",
		"suborder_deleted": "De deelbestelling is succesvol verwijderd",
		"suborder_deleted_error": "Er is een fout opgetreden bij het verwijderen van de deelbestelling",
		"error_cancelling_suborder": "Er is een fout opgetreden tijdens het annuleren van deze bestelling",
		"timing": "Timing",
		"scenario": "Scenario"
	},
	"checkout": {
		"modal_title": "Bedankt om gebruik te maken van one2three!",
		"modal_text_group": "Uw bestelling is ontvangen, maar nog niet aangeboden aan de handelaar voordat hij door de Groep eigenaar is verzonden! We houden je op de hoogte.",
		"modal_text": "Je bestelling wordt door ons verwerkt! We houden je op de hoogte.",
		"order_code": "Bestellingscode",
		"delivery_method": "Leveringsmethode",
		"estimated_delivery_time": "Geschatte afleveringstijd",
		"delivery_location": "Plaats van levering",
		"transaction_id": "Transactie ID",
		"timing": "Selecteer tijdstip:",
		"from": "vanaf",
		"basket_title": "Mijn bestelling",
		"header_order": "Details bestelling",
		"header_payments": "Details betaling",
		"back_to_menu": "Nog iets vergeten? Klik hier!",
		"invoice_check": "Ik wens een factuur te ontvangen.",
		"extra_info": "Extra informatie",
		"no_of_persons": "Aantal personen"
	},
	"contact": {
		"contact_us": "Contacteer ons",
		"opening_hours": "Openingsuren",
		"comment": "Commentaar",
		"success": "Succes! Bedankt dat u contact met ons hebt opgenomen. We nemen zo nodig zo snel mogelijk contact met u op.",
		"error": "Er is een fout opgetreden bij het contacteren",
		"all_fields_mandatory": "al deze velden zijn verplicht",
		"closing_days": "Sluitingsdagen"
	},
	"groups": {
		"add_group": "Nieuwe groep",
		"approved_success": "De groep is succesvol aanvaard",
		"rejected_success": "De groep is succesvol geweigerd",
		"merchant_group_error": "Er is een fout opgetreden tijdens het aanmaken van de groep"
	},
	"group_member": {
		"title": "Groepsleden",
		"email": "Email van nieuw lid",
		"added": "Je bent als lid toegevoegd aan deze groep",
		"removed": "Het groepslid is succesvol verwijderd",
		"invitation_sent": "Er is een uitnodiging verstuurd naar dit e-mailadres",
		"add_error": "Er is een fout opgetreden bij het toevoegen van u als lid"
	},
	"payment_method": {
		"CASH": "Contant betalen",
		"CASH_kiosk": "Betalen aan de kassa",
		"CASH_takeaway": "Ter plaatse betalen",
		"CASH_waiter": "Contant betalen",
		"CASH_delivery": "Betalen bij levering",
		"CASH_eatin": "Ter plaatse betalen",
		"CASH_catering": "Contant betalen",
		"CASH_table": "Betalen aan de kassa",
		"CASH_roomservice": "Contant betalen",
		"CASH_ADMIN": "Contant betalen (beheerder)",
		"MONIZZEMEAL": "Monizze Maaltijdcheques",
		"CCMOLLIE": "Kredietkaart",
		"BCMCMOLLIE": "Bancontact",
		"PAYPALMOLLIE": "PayPal",
		"IDEALMOLLIE": "iDEAL",
		"TERMINALMOLLIE": "Betaling met kaart (Mollie)",
		"PAYCONIQ": "Payconiq",
		"INVOICE": "Betaling op factuur",
		"title": "Kies je betaalmethode",
		"edit": "Wijzig",
		"APPLEPAYMOLLIE": "Apple Pay",
		"WORLDLINE": "Betaling met kaart",
		"CCV": "Betaling met kaart",
		"WALLET": "Wallet",
		"PAY_LATER": "Later betalen",
		"payment_terminal": "Betaalterminal"
	},

	"payment_brand": {
		"Cash": "Cash",
		"Bancontact": "Bancontact",
		"Mastercard": "Mastercard",
		"Visa": "Visa",
		"Meal_Vouchers": "Maaltijdcheques",
		"Payconiq": "Payconiq",
		"PayPal": "PayPal",
		"iDEAL": "iDEAL",
		"Apple Pay": "Apple Pay",
		"Apple_Pay": "Apple Pay",
		"Bitcoin": "Bitcoin",
		"Maestro": "Maestro",
		"Wallet": "Wallet",
		"Invoice": "Factuur",
		"Monizze": "Monizze",
		"Sodexo": "Sodexo",
		"Edenred": "Edenred",
		"Pay_later": "Later betalen",
		"ALL": "Alle betaalmethoden"
	},

	"payment_state": {
		"paid": "betaald",
		"unpaid": "onbetaald",
		"all": "alle"
	},
	"device_type": {
		"all": "Alle",
		"AndroidV2": "Android",
		"iOSV2": "iOS",
		"web v2": "Web",
		"Kiosk": "Kiosk",
		"POS": "POS"
	},
	"about_us": {
		"over": "Over",
		"general_info": "Algemene informatie",
		"hours": "Openingsuren",
		"social": "Sociale Media"
	},
	"order_unit": {
		"g":"g",
		"kg":"kg",
		"slices":"snedes",
		"persons":"personen",
		"person":"pers."
	},
	"order_type": {
		"personal": "individuele bestelling",
		"group": "Groepsbestelling",
		"subtitle": "Wil je voor jezelf of in groep bestellen?",
		"edit": "Wijzig"
	},
	"order_status": {
		"sent": "Je bestelling is verzonden",
		"response": "Bedankt voor je bestelling!",
		"feedback_begin": "Je bestelling werd verstuurd naar {{ merchant_name }}.",
		"feedback_end": "Zij houden je op de hoogte wanneer je bestelling klaar is. Vergeet dus zeker je mail of sms-inbox niet te controleren!",
		"feedback_short_begin": "Je bestelling werd verstuurd.",
		"feedback_short_end": "Je kan de status van je bestelling opvolgen in je profiel.",
		"profile_link": "Je kan de status van je bestelling ook opvolgen in je profiel.",
		"back_to_menu": "Nog iets vergeten? Klik hier!",
		"new_order": "Plaats hier een nieuwe bestelling!",
		"my_orders": "Volg de status van je bestelling",
		"joyn_text": "Bij elke online aankoop krijg je punten van ons. Die kan je later inruilen voor toffe beloningen en extra kortingen.",
		"joyn_points_begin": "Deze code bevat ",
		"joyn_points_end": " punten",
		"joyn_collect": "Verzilver mijn punten in de app",
		"route": "Routebeschrijving naar deze zaak",
		"table_order_received": "{{ merchant_name }} heeft je bestelling goed ontvangen.\nMen zal dit zo spoedig mogelijk aan tafel brengen",
		"table_order_received_real_user": "of je zal verwittigd worden per mail en/of sms wanneer je dit mag afhalen"
	},
	"scenario": {
		"all": "alle",
		"takeaway": "afhalen",
		"takeaway_kiosk": "meenemen",
		"delivery": "leveren",
		"eatin": "ter plaatse",
		"catering": "catering",
		"table": "tafel",
		"reservation": "reserveren",
		"roomservice": "room service",
		"terminal": "terminal",
		"waiter": "ober",
		"subtitle": "Kies je soort bestelling",
		"edit": "Wijzig",
		"select_table": "Selecteer tafel",
		"choose_your_location": "Kies je locatie",
		"choose_your_catering_location": "Kies je catering locatie",
		"no_delivery_on_chosen_address": "Helaas leveren we niet op het door jou gekozen adres."

	},
	"timing": {
		"asap": "Zo snel mogelijk",
		"timed": "Tijdstip",
		"subtitle": "Wanneer wil je jouw bestelling ontvangen?",
		"subtitle_pos": "Kies de gewenste dag en het gewenste tijdstip",
		"edit": "Wijzig",
		"slot_title": "Kies het gewenste tijdstip",
		"day_title": "Kies de gewenste dag",
		"monday": "Maandag",
		"tuesday": "Dinsdag",
		"wednesday": "Woensdag",
		"thursday": "Donderdag",
		"friday": "Vrijdag",
		"saturday": "Zaterdag",
		"sunday": "Zondag",
		"h": "u",
		"at": "om",
		"block": "tussen {{ begin }} en {{ end }}"
	},
	"venues": {
		"search": "Zoeken",
		"open": "Open deze zaak",
		"no_favourites": "Je hebt nog geen favoriete zaken toegevoegd. Klik op het hartje om een zaak toe te voegen aan je favorieten."
	},
	"voucher": {
		"subtitle": "Heb je een waardebon? Vul hier de code in.",
		"placeholder": "Waardebon code",
		"confirm": "Valideer",
		"feedback_begin": "Er werd ",
		"feedback_end": " van je bestelbedrag afgetrokken. Het nieuwe saldo van je waardebon bedraagt ",
		"feedback": "Er werd {{ amount }} van je bestelbedrag afgetrokken. Het nieuwe saldo van je waardebon bedraagt {{ amount_left }}",
		"feedback_generic": "Er werd {{ amount }} van je bestelbedrag afgetrokken.",
		"used_already": "Coupon reeds gebruikt",
		"invalid": "Ongeldige code"
	},
	"input_loyalty_card": {
		"subtitle": "Punten sparen? Vul hier het nummer van je klantenkaart in.",
		"placeholder": "Klantenkaart code",
		"confirm": "Bevestig",
		"invalid": "Ongeldige code, de code moet uit 6 cijfers bestaan"
	},
	"suggestions": {
		"subtitle": "Anderen bestelden ook...",
		"add": "Voeg toe"
	},
	"qrscan": {
		"back": "Terug",
		"success_connect_loyalty_card": "Proficiat, jouw klantenkaart is nu geactiveerd!"
	},
	"product": {
		"title": "Productbeschrijving",
		"add_to_basket": "Voeg toe",
		"out_of_stock": "Uitverkocht",
		"ingredients": "(Verwijderbare) Ingrediënten"
	},
	"order_detail": {
		"title": "Details bestelling"
	},
	"option": {
		"radio_title": "Gelieve één optie te kiezen",
		"checkbox_title": "Je kan {{ min_select }} tot {{ max_select }} opties kiezen",
		"checkbox_title_begin": "Je kan ",
		"checkbox_title_mid": " tot ",
		"checkbox_title_end": " opties kiezen"
	},
	"basket": {
		"title": "Mijn bestelling",
		"empty": "Je hebt nog geen producten aan je bestelling toegevoegd...",
		"subtotal": "Subtotaal"
	},
	"location": {
		"title": "Details locatie",
		"address_search": "Vul je adres in",
		"validate": "Controleer hieronder jouw adresgegevens",
		"info_message": "Indien je je bestelling wilt laten leveren, gelieve je huisnummer correct in te vullen.",
		"confirm": "Adres bevestigen",
		"add_address_line2":"voeg hier uw busnr/appartementsnr toe"
	},
	"registry": {
		"true": "Ok",
		"false": "Probleem"
	},
	"level_of_activity_admin": {
		"title": "Drukte indicator",
		"-1": "Blauw",
		"0": "Normaal",
		"1": "Drukker dan normaal",
		"2": "Zeer druk"
	},
	"level_of_activity": {
		"0": "",
		"1": "Het is drukker dan normaal. Verwacht vertragingen.",
		"2": "Het is zeer druk. U kan momenteel niet bestellen."
	},
	"defaults": {
		"timing": "We hebben de eerstvolgende timing gekozen. Je kan deze zelf indien gewenst nog aanpassen.",
		"timing_catering": "We hebben de eerstvolgende timing alsook de catering locatie gekozen. Je kan deze zelf indien gewenst nog aanpassen.",
		"catering": "We hebben de catering locatie gekozen. Je kan deze zelf indien gewenst nog aanpassen."
	},
	"payment_terminal": {
		"failed": "De betaling werd niet voltooid.",
		"instructions": "Gelieve de instructies op de betaalterminal te volgen.",
		"protection_hands": "Hou je vrije hand over de vinger waarmee je je geheime code intikt zodat niemand kan meekijken."
	},
	"print_job_status": {
		"queued": "in de wachtrij",
		"in_progress": "wordt geprint",
		"done": "geprint"
	},
	"settings": {
				"general": "Algemene instellingen",
				"description": "Beschrijving",
				"domain": "Domein",
				"tags": "Tags",
				"add_tag": "Tag toevoegen",
				"logo": "Logo",
				"contact": "Contact",
				"short_description": "Korte beschrijving",
				"add_image": "Afbeelding toevoegen",
				"edit_image": "Afbeelding bewerken",
        "reference": "Referentie",
        "comment": "Commentaar",
        "others": "Overige instellingen",
        "cash_description": "Omschrijving CASH betaalmethode",
        "loyalty_points": {
            "enabled": "Klantenkaart actief",
            "order_amount": "Basis spaarregel",
            "order_amount_description": "getrouwheidspunten per gespendeerde euro (optioneel)",
            "extra": "Extra spaarregels"
        },
				"drop_files_here": "Sleep bestanden hierheen",
				"or_browse": "Afbeelding...",
        "orders": "Bestellingen",
        "template": "Sjabloon",
        "templates_names": {
            "template1": "Sjabloon zonder categorie overzicht",
            "template2": "Sjabloon met categorie overzicht"
        },
        "orders_sorted_by": "Bestellingen sorteren op",
        "order_by": {
            "dist_timing_target": "Richttijd",
            "kiosk_number": "Kiosk nummer"
        },
        "facebook_url": "Facebook url",
        "instagram_url": "Instagram url",
        "twitter_url": "Twitter url",
        "mobile_primary_color": "Primaire kleur voor mobiele styling",
        "mobile_secondary_color": "Mobiele styling secundaire kleur",
        "google_analytics": "Google Analytics tracking ID",
        "style": "Stijl",
        "features": "Functionaliteiten",
        "closing": "Noodgeval sluiting",
        "closed": "Nu gesloten",
        "closed_message": "Sluitingsbericht",
        "timezone": "Tijdszone",
        "timeslots": "Tijdsblok",
        "addtimeslot": "Tijdsblok toevoegen",
        "from": "van",
        "to": "tot",
        "to_included": "tot en met",
        "add": "Toevoegen",
        "currency": "Valuta",
				"vat_number": "BTW nummer",
				"vat_number_error": "Gelieve een geldig BTW nummer in te voeren",
        "joyn_reference": "Joyn Referentie",
        "invalid_hex_color": "Voer een geldige hexadecimale CSS-kleur in.",
				"venue_updated_succesfully": "Instellingen succesvol bijgewerkt",
				"venue_updated_error": "Er is een fout opgetreden bij het bijwerken van de instellingen, gelieve het later opnieuw te proberen",
        "address": {
						"title": "Adres",
            "line1": "regel 1",
            "line2": "regel 2",
            "zipcode": "postcode",
            "city": "stad",
            "country": "land"
        },
        "promotion": {
            "promotion":"Informatie popup",
            "title": "Titel",
            "description": "Beschrijving",
            "ios_enabled": "IOS Ingeschakeld",
            "android_enabled": "Android Ingeschakeld",
            "web_enabled": "web-Enabled",
            "error_required": "Als promotie ingeschakeld is, is een titel en beschrijving vereist"
        },
        "ordering": "Bestellen",
        "orderstates":{
            "supported_states": "Mogelijke statussen",
            "visible_states": "Zichtbare statussen",
            "zipcodes": "Toegelaten postcodes voor leveringen",
            "countries": "Toegelaten landen voor leveringen",
            "set_states": "Status instellen",
            "order_method": "Bestel Methode",
            "local_ordering": "Ter plaatse bestellen",
            "location": "Locatie",
            "add_location": "Add a location"
        },
        "email_addresses": {
            "title": "E-mailadressen goedgekeurd voor zaak met beperkte toegang",
            "placeholder": "Vul hier jouw e-mailadressen in"
        },
        "domains": {
            "title": "E-mailadomeinen goedgekeurd voor zaak met beperkte toegang",
            "placeholder": "Voer je e-maildomeinen in"
        },
        "order_and_reward": {
            "enabled": "Order & Reward actief",
            "order_amount": "Reward per aantal bestellingen",
            "reward_value": "Waarde van de reward (in €)"
        },
        "printing":{
            "printer_address": "Printer adres",
            "cloud_print": "Cloud printer",
            "printer_cloud_address": "MAC adres",
            "printer_email_address": "Email",
            "name": "@:name",
            "printing": "Printen",
            "type": "Type",
            "host": "Host-adres",
            "host_too_long": "Host IP is te lang (maximum is 15 tekens)",
            "host_too_short": "Host IP is te kort (maximaal 7 tekens)",
            "host_required": "Host IP is vereist",
            "automatic": "Automatisch printen",
            "automatic_amount": "Aantal kopieën",
            "content_reference": "Klantreferentie",
            "content_scenario": "Scenario",
            "content_immediate_order": "Bezorgopties",
            "content_order_time": "Tijdstip bestelling",
            "content_target_time": "Geschatte levertijdstip",
            "content_order_location": "Bestelling locatie",
            "content_distribution_location": "Afleverlocatie",
            "content_payment_state": "Betaalstatus",
            "content_payment_method": "Betaalmethode",
            "content_qr": "QR code",
            "content_order_lines": "Inhoud bestelling",
            "content_categories": "Categorie titels",
            "content_total": "Totaalbedrag bestelling",
            "content_number": "Ordernummer",
            "content_mobile": "Klant GSM",
            "content_email": "Klant email",
            "configuration_title": "Printer configuratie",
            "content_title": "Ticket inhoud",
            "content_subtotal": "Subtotaal",
            "content_message": "Bericht",
            "content_no_of_persons": "Aantal personen",
            "content_payment_status": "Betalingsstatus",
            "content_comment": "Comment",
            "content_per_product": "1 product = 1 ticket",
            "tabs": "Print rekeningen",
            "printers": "Printers",
            "addprinter": "Printer toevoegen",
            "deleteprinter": "Printer verwijderen",
            "message": "Bericht",
            "whitespaces": "Aantal leidende witregels",
            "print_settings_title": "Ticket instellingen",
            "print_settings_description": "Kies hoe bestellingen in tickets worden ingedeeld.",
            "content_consolidated_order": "1 bestelling = 1 ticket",
            "content_detailed_orders": "Gedetailleerde bestelling afdrukken op 1 ticket.",
            "content_main_separate_tickets": "1 bestelling = 1 ticket + afsplitsing groepsbestellingen",
            "content_level_of_activity": "Level of activity",
            "content_coupons": "Coupons",
            "content_package": "Pakket",
            "content_category": "Categorie",
            "content_products": "Producten",
            "content_quantity": "Aantal stuks",
            "check_status": "Controleer de status",
            "printer_ip": "Printer IP",
            "types": {
                "orders": "Bestellingen",
                "bills": "Biljetten",
                "labels": "Labels"
            }
        },
        "block_duration": {
            "title": "Duur van het tijdsblok (in minuten)"
        },
        "block_display": {
            "title": "Tijdsblok getoond als"
        },
        "kiosk": {
            "kiosks": "Kiosken",
            "mode": "Mode",
            "kiosk": "Bestel op de kiosk",
            "counter": "Ontvang een nummer en bestel aan de toog",
            "reservation": "Nummerreservering",
            "order_finished": "Bij afronden van bestelling",
            "order_started": "Bij bestelling gestart",
            "add_kiosk": "Voeg Kiosk toe",
            "delete_kiosk": "Verwijder Kiosk"
        },
        "queue": "Wachtrij",
        "local_ordering_delivery": "Ter plaatse bestellen (afleveren)",
        "local_ordering_delivery_lead_time": "Benodigde tijd om ter plaatse te bestellen (afleveren)",
        "local_ordering_delivery_lead_time_help": "Benodigd aantal minuten voor sluitingstijd om ter plaatse te kunnen bestellen (afleveren)",
        "local_ordering_pickup": "Ter plaatse bestellen (afhalen)",
        "local_ordering_pickup_lead_time": "Benodigde tijd om ter plaatse te bestellen (afhalen)",
        "local_ordering_pickup_lead_time_help": "Benodigd aantal minuten voor sluitingstijd om ter plaatse te kunnen bestellen (afhalen)",
        "remote_ordering_delivery": "Op afstand bestellen (afleveren)",
        "remote_ordering_delivery_lead_time": "Benodigde tijd om op afstand te bestellen (afleveren)",
        "remote_ordering_delivery_lead_time_help": "Benodigd aantal minuten voor sluitingstijd om op afstand te kunnen bestellen (afleveren)",
        "remote_ordering_pickup": "Op afstand bestellen (afhalen)",
        "remote_ordering_pickup_lead_time": "Benodigde tijd om op afstand te bestellen (afhalen)",
        "remote_ordering_pickup_lead_time_help": "Benodigd aantal minuten voor sluitingstijd om op afstand te kunnen bestellen (afhalen)",
        "days_in_advance": "Dagen op voorhand",
        "default_payment_method": "Standaard betaalmethode",
        "countdown_time_till_ready": "Countdown tijd getoond bij status",
        "opening-hours": "Openingsuren",
        "public_email": "Publieke e-mail",
				"public_email_error": "Gelieve een geldig email adres in te vullen.",
        "public_phone": "Publieke telefoon",
				"public_phone_error": "Gelieve een geldig telefoonnummer in te vullen dat begint met +32 (België), +33 (Frankrijk) of +31 (Nederland).",
        "scanning": "Scannen",
        "scanning_automatic": "Automatisch scannen",
        "scanning_state": "Status na scannen",
        "scanning_camera": "Gebruik camera aan de voorzijde om te scannen",
        "takeaway_time_till_ready": "Bereidingstijd voor afhalen",
        "takeaway_time_till_ready_help": "Bereidingstijd, staat in bericht naar klant",
        "takeaway_lead_time": "Benodigde tijd om af te halen",
        "takeaway_lead_time_help": "Benodigde tijd om af te halen (in seconden)",
        "catering_time_till_ready": "Catering tijd tot klaar",
        "catering_time_till_ready_help": "Bereidingstijd, staat in bericht naar klant",
        "catering_lead_time": "Benodigde tijd voor catering",
        "catering_lead_time_help": "Benodigde tijd voor catering (in seconden)",
        "eatin_time_till_ready": "Bereidingstijd voor bestellingen ter plaatse",
        "eatin_time_till_ready_help": "Bereidingstijd, staat in bericht naar klant",
        "eatin_lead_time": "Benodigde tijd voor bestellingen ter plaatse",
        "eatin_lead_time_help": "Benodigde tijd voor bestellingen ter plaatse (in seconden)",
        "delivery_time_till_ready": "Bereidingstijd voor leveringen",
        "delivery_time_till_ready_help": "Bereidingstijd, staat in bericht naar klant",
        "delivery_lead_time": "Benodigde tijd voor leveringen",
        "delivery_lead_time_help": "Benodigde tijd voor leveringen (in seconden)",
        "table_time_till_ready": "Bereidingstijd voor bediening aan tafels",
        "table_time_till_ready_help": "Bereidingstijd, staat in bericht naar klant",
        "table_lead_time": "Benodigde tijd voor bediening aan tafels",
        "table_lead_time_help": "Benodigde tijd voor bediening aan tafels (in seconden)",
        "terminal_time_till_ready": "Bereidingstijd voor terminals",
        "terminal_time_till_ready_help": "Bereidingstijd, staat in bericht naar klant",
        "terminal_lead_time": "Benodigde tijd voor terminals",
        "terminal_lead_time_help": "Benodigde tijd voor terminals (in seconden)",
        "roomservice_time_till_ready": "Bereidingstijd voor room service",
        "roomservice_time_till_ready_help": "Bereidingstijd, staat in bericht naar klant",
        "roomservice_lead_time": "Benodigde tijd voor room service",
        "roomservice_lead_time_help": "Benodigde tijd voor room service (in seconden)",
        "waiter_time_till_ready": "Bereidingstijd voor bediening",
        "waiter_time_till_ready_help": "Bereidingstijd, staat in bericht naar klant",
        "waiter_lead_time": "Benodigde tijd voor bediening",
        "waiter_lead_time_help": "Benodigde tijd voor bediening (in seconden)",
        "website_header": "Website header",
        "venue_interior": "Afbeelding van de zaak",
        "reference_enabled": "Referentie ingeschakeld?",
        "reference_required": "Referentie verplicht?",
        "comment_enabled": "Commentaar ingeschakeld?",
        "comment_characters": "Maximum characters commentaarveld",
        "comment_required": "Commentaar verplicht?",
        "private_shop": "Zaak met beperkte toegang?",
        "reference_title": "Referentie Titel",
        "comment_title": "Opmerkingen Titel",
        "comment_title_required": "Comment titel nodig.",
        "comment_title_too_long": "Reactie titel is te lang. Maximum is 50 tekens.",
        "autogroup_products": "Automatisch groeperen producten",
        "waiter_only": "Enkel obers bestellen?",
        "immediate_order": "Voor onmiddelijke consumptie/zelf te bereiden?",
        "device":
        {
            "device": "Apparaat",
            "name": "@:name",
            "hide_tab": "Verberg rekeningen op dit apparaat",
            "add_device_configuration": "Creëer nieuwe configuratie",
            "use_default_configuration": "Gebruik standaard configuratie",
            "supported_taxons": "Ondersteunde categorieën",
            "deviceConfig": "Apparaat Configuratie",
            "invalid_device_name": "Apparaat Naam is verplicht"
        },
        "payment":
        {
            "payment": "Betaling",
            "entity_id": "Entiteit Id",
            "user_id": "Gebruikersnaam",
            "password": "Wachtwoord",
            "add_credentials": "Voeg Betaling Credentails",
            "resource": "betaling referenties",
            "paymentConfig": "Payment Configuration",
            "payment_method": {
                "cash": "CASH",
                "invoice": "Factuur",
                "visa": "VISA",
                "master": "MasterCard",
                "bcmc": "Bancontact/MisterCash",
                "maestro": "MAESTRO",
                "ideal": "IDEAL",
                "monizze_meal": "Monizze Maaltijdcheques",
                "visa_ems": "VISA EMS",
                "master_ems": "MasterCard EMS",
                "bcmc_ems": "Bancontact/MisterCash EMS",
                "paypal": "PayPal",
                "payconiq": "Payconiq",
                "cc_mollie": "Kredietkaarten Mollie",
                "bcmc_mollie": "Bancontact/MisterCash Mollie",
                "paypal_mollie": "PayPal Mollie",
                "bitcoin_mollie": "Bitcoin Mollie",
                "ideal_mollie": "iDeal Mollie",
                "applepay_mollie": "Apple Pay Mollie",
                "worldline": "Worldline terminal",
                "ccv": "CCV terminal"
                },
            "errors": {
                "entity_id": {
                    "required": "Entiteit Legitimatie is verplicht.",
                    "too_short": "Entiteit-id is te kort! (Minimum is 32 tekens)",
                    "too_long": "Entiteit -id is te lang! ( Maximum is 32 tekens)"
                },
                "user_id": {
                    "required": "Gebruikers-ID is vereist.",
                    "too_short": "Gebruikers-id is te kort! (Minimum is 32 tekens)",
                    "too_long": "Gebruikers-id is te lang! ( Maximum is 32 tekens)"
                },
                "password": {
                    "required": "Een wachtwoord is verplicht.",
                    "too_long": "Wachtwoord is te lang! ( Maximum is 32 tekens)",
                    "too_short": "Wachtwoord is te kort! ( Minimum 8 tekens)"
                },
                "payment_method_required": "Please select at least one payment method"
            }
        },
        "registry": {
            "settings": "Instellingen",
            "registry": "Type kassa",
            "table_start":"Bestellingen starten bij tafel",
            "registry_day_starts_at": "Bestellingen worden doorgestuurd vanaf",
            "registry_configuration": "Kassa configuratie",
            "is_product_mandatory": "Is de product ID verplicht?",
            "user": "Gebruiker",
            "password": "Wachtwoord",
            "ip_address": "IP adres",
            "sync_products": "Synchroniseer producten",
            "sync_prices": "Synchroniseer prijzen",
            "verify_prices": "Vergelijk prijzen",
            "unsynced_products": "Niet gesynchroniseerde producten",
            "mismatched_products": "Producten met kassa ID die niet of foutief in kassa voorkomen",
            "registry_products": "Lijst van producten in de kassa",
            "registry_payment_methods": "Lijst van betalingsmethoden in de kassa",
            "registry_tables": "Lijst van tafels in de kassa",
            "unsynced_orders": "Bestellingen die niet naar de kassa gesyncd konden worden",
            "retrieve_list": "Lijst ophalen",
						"order_state": "Push bestelling bij status:",
						"ip": "IP adres"
        }
    },
		"cookie": {
			"header": "Cookies",
			"message": "Deze website maakt gebruik van cookies om uw ervaring te verbeteren.",
			"dismiss": "Oké",
			"allow": "Cookies toestaan",
			"deny": "Cookies weigeren",
			"link": "Meer info",
			"policy": "Cookiebeleid"
	},
	"customers": {
		"date_last_order": "Datum laatste bestelling",
		"download_csv": "Download CSV",
		"number_of_orders": "Aantal bestellingen",
		"total_value": "Totale waarde",
		"first_order": "Eerste bestelling",
		"last_order": "Laatste bestelling",
		"points": "Punten",
		"overview_points": "Punten",
		"all": "Alle",
		"last_week": "Laatste week",
		"last_month": "Laatste maand",
		"last_3_months": "Laatste 3 maanden",
		"not_in_3_months": "Niet in 3 maanden",
		"not_in_1_month": "Niet in 1 maand",
		"earned": "Verdiend",
		"modified": "Aangepast",
		"spent": "Uitgegeven",
		"total_number_points": "Totaal aantal punten",
		"add_or_subtract_points": "Punten toevoegen of verminderen (min: -500, max: 500):",
		"amount": "Aantal",
		"modify": "Aanpassen",
		"amount_points": "Aantal punten",
		"earned_at": "Verdiend op",
		"state": "Status",
		"new_customer": "Nieuwe gebruiker",
		"username": "Gebruikersnaam",
		"username_error": "Gelieve een gebruikersnaam in te vullen",
		"email": "E-mail",
		"email_error": "Gelieve een e-mailadres in te vullen",
		"badge_number": "Badge nummer",
		"phone": "Telefoonnummer",
		"phone_error": "Gelieve een geldig telefoonnummer in te vullen dat begint met +32 (België), +33 (Frankrijk) of +31 (Nederland).",
		"locale": "Taal",
		"locale_error": "Gelieve een taal te selecteren",
		"error": "Er liep iets fout, gelieve alle velden te controleren en opnieuw te proberen."
	},
	"coupon": {
		"new": "Nieuwe coupon",
		"code": "Code",
		"type": "Type",
		"description": "Beschrijving",
		"state": "Status",
		"balance": "Saldo",
		"expiry_date": "Vervaldatum",
		"redeem_now": "Inwisselen",
		"charge": "Opladen",
		"change_expiry_date": "Vervaldatum wijzigen",
		"action": "Actie",
		"amount": "Bedrag",
		"date": "Datum",
		"changed_by": "Gewijzigd door",
		"number_of_coupons": "Aantal coupons",
		"does_not_expire": "Vervalt niet",
		"valid_from": "Geldig vanaf",
		"cancel": "Annuleren",
		"save": "Opslaan",
		"general": "Algemeen",
		"valid": "Geldig",
		"void": "Ongeldig",
		"redeem": "Ingewisseld",
		"redeemed": "Ingewisseld",
		"future": "Nog niet geldig",
		"generic": "Generiek",
		"unique": "Uniek",
		"deposit": "Opgeladen",
		"create": "Aangemaakt",
		"search": "Zoeken",
		"amount_negative": "Bedrag moet positief zijn",
		"amount_more_than_balance": "Bedrag moet kleiner zijn dan het saldo",
		"coupon_created": "Coupon succesvol aangemaakt",
		"coupon_deleted": "Coupon succesvol verwijderd",
		"coupon_amount_updated": "Het saldo werd succesvol gewijzigd",
		"coupon_expiry_date_updated": "De vervaldatum werd succesvol gewijzigd",
		"date_invalid": "De vervaldatum mag niet voor de eerste dag van de geldigheidsperiode liggen",
		"amount_label": "Geef bedrag in (inclusief BTW):",
		"download_csv": "Download als CSV",
		"one_created": "Coupon aangemaakt",
		"multiple_created": "Coupons aangemaakt",
		"download_possible": "Uw coupons werden aangemaakt, u kan ze nu downloaden als CSV bestand.",
		"close_without_download": "Sluiten zonder downloaden",
		"field_required": "Dit veld is verplicht",
		"date_later_than_valid_from": "De vervaldatum moet later zijn dan de eerste dag van de geldigheidsperiode"
	},
	"tabs": {
		"per_customer": "Per klant",
		"one_off": "Eenmalig",
		"add": "Toevoegen",
		"closed_successful": "De rekening werd succesvol gesloten",
		"closed_error": "Er ging iets mis, probeer het later opnieuw",
		"price_modification_applied": "De prijsaanpassing werd toegepast",
		"price_modification_deleted": "De prijsaanpassing werd verwijderd",
		"price_modification_error": "Er ging iets mis, probeer het later opnieuw",
		"close": "Afsluiten",
		"modified": "Aangepast"
	},

	"fol": {
		"find_venue": "Vind een frituur",
		"show_on_map": "Toon op kaart",
		"place_order": "Plaats uw bestelling",
		"open_map": "Bekijk hier de kaart",
		"main_sentence": "Vermijd wachtrijen en bestel online!",
		"scroll": "Scroll naar beneden",
		"how_to_order": "Hoe kan je bestellen?",
		"step_1": "Kies uw scenario",
		"step_2": "Kies uw eethuis",
		"step_3": "Plaats uw bestelling",
		"step_4": "Betaal en geniet!",
		"become_partner": "Ik heb interesse om partner te worden",
		"become_client": "Ik heb interesse in het platform",
		"follow_us": "Volg ons",
		"ordering!": "Bestellen!",
		"about_us": "Over ons",
		"part_1": "Hét online bestelplatform waarmee u uw omzet nog meer kan verhogen terwijl u geniet van een persoonlijke service.",
		"part_2": "Wie zijn wij?",
		"part_3": "Enkele jaren geleden zijn wij gestart als bestelplatform voor frituren.",
		"part_4": "Intussen zijn we uitgegroeid tot een bekend en vertrouwd platform met een groot en tevreden klantenbestand over heel Vlaanderen. We hebben ons recent ook opengesteld naar andere horecazaken.",
		"part_5": "Heeft u dus een broodjeszaak, pizzazaak, kebabzaak,… dan kan u ook bij ons terecht. Onze naam frietjesonline.be behouden we omdat we beseffen dat we intussen een groot consumentenbestand hebben opgebouwd, en vertrouwen uitstralen.",
		"part_6": "Features",
		"part_7": "We luisteren naar uw noden en stippelen voor u de meest passende werking uit (tijdstippen, voorafbestellen, … )",
		"part_8": "Sterke service",
		"part_9": "We streven naar een service waarin we u ten allen tijde ondersteunen, wij zorgen voor de brug tussen u en uw klant",
		"part_10": "Geen vaste kosten",
		"part_11": "U betaalt geen instap-, maandelijkse of uitstapkost",
		"part_12": "Blijven innoveren",
		"part_13": "We hebben oor naar uw feedback en trachten steeds te vernieuwen en te verbeteren in functie van uw behoeften en wensen maar ook die van de consument",
		"part_14": "Gratis reclame",
		"part_15": "We maken reclame voor uw zaak",
		"part_16": "Platform:",
		"part_17": "Via ons platform www.frietjesonline.be vinden nieuwe klanten uw zaak snel. Er komen steeds meer diverse foodaccounts bij, waardoor het aanbod voor uw klant steeds groter wordt en er steeds meer consumenten hiervan gebruik maken.",
		"part_18": "QR code en URL:",
		"part_19": "Via uw unieke QR code en URL vinden uw vertrouwde klanten snel uw eigen webshop en worden ze rechtstreeks doorgestuurd naar u.",
		"part_20": "Op uw lijf geschreven:",
		"part_21": "Wij bespreken samen met u de meest passende manier van werken. Alle opties zijn mogelijk. U kan uw klant voor uw openingsuren laten bestellen, u kan dit wel of niet laten doorlopen en desgewenst aanpassen/uitzetten tijdens uw shift, leveren… U kan zelf creatief aan de slag in uw assortiment, prijzen aanpassen, producten toevoegen verwijderen, eigen foto’s toevoegen, ruimte voor mededelingen voor uw klant, …",
		"part_22": "Op het lijf van uw klant geschreven:",
		"part_23": "Uw klant kan zijn favoriete zaak en diens producten aanduiden, kan zijn bestellijst opslaan en zo sneller en eenvoudiger bestellen. Vragen worden steeds door ons gehoord en snel opgevolgd.",
		"part_24": "Quotes van klanten:",
		"part_25": "“Ik was niet zo overtuigd dat een online systeem een meerwaarde zou zijn, ik had reeds een zeer goed draaiende zaak. Echter heb ik sinds mijn aansluiting bij frietjesonline mijn omzet nog meer zien stijgen. Omwille van de voorafbestellingen en tijdslots, bespaar ik in mijn voorbereidingstijd en kan ik nog veel meer bestellingen verwerken. “",
		"part_26": "“ Ik had nooit gedacht dat mijn omzet nog zo veel meer kon stijgen, we hebben intussen 4 brommers rondrijden om te leveren!”",
		"part_27": "Quotes van consumenten:",
		"part_28": "“ Door de aantrekkelijke foto’s die bij de producten staan, bestel ik elke keer eens iets anders.”",
		"part_29": "“ Wij bestellen elke week steeds hetzelfde en het liefst rond hetzelfde uur. Super handig met ‘Mijn bestelling’ en de tijdslotjes.“",
		"part_30": "Interesse? Héél eenvoudig!",
		"part_31": "Als friturist kan je vrijblijvend contact met ons opnemen voor meer informatie."
	},

	"employees": {
		"employees": "Medewerkers",
		"distributors": "Koeriers",
		"admins": "Beheerders",
		"super_admins": "Super Beheerders",
		"edit_user": "Gebruiker bewerken",
		"user_updated_succesfully": "Gebruiker succesvol aangepast",
		"user_updated_error": "Er ging iets mis, probeer het later opnieuw"
	},
	"welcome": {
		"only_admin_allowed": "Enkel beheerders kunnen deze pagina bekijken",
		"need_to_enable_feature": "Je moet deze functionaliteit eerst activeren voor je deze pagina kan bekijken",
		"future_functionality": "Deze functionaliteit is nog niet beschikbaar"
	},
	"pos_price_mod": {
		"order": "Bestelling",
		"product": "Product",
		"active": "Actief",
		"inactive": "Inactief",
		"add": "Prijsaanpassing toevoegen",
		"general": "Algemeen",
		"values": "Waarden",
		"weekly_schedule": "Weekschema",
		"selectable_by_user": "Toepasbaar op rekeningen",
		"has_weekschedule?": "Heeft weekschema?",
		"description": "Beschrijving",
		"price_adapt": "Prijsaanpassing",
		"price_adapt_method": "€/%",
		"registry_id": "Kassa item ID",
		"minimum_price": "Minimum prijs",
		"maximum_price": "Maximum prijs",
		"cut_off": "Cut off",
		"scenarios": "Scenarios",
		"order_location_types": "Bestellocatie (type)",
		"dist_location_types": "Afleverlocatie (type)",
		"dist_timings": "Leveringstijden",
		"zipcodes": "Postcode",
		"category": "Categorieën",
		"category_with_name": "Categorieën",
		"payment_methods": "Betaalmethoden",
		"group_types": "Groepen (type)",
		"groups": "Groepen",
		"groups_with_name": "Groepen",
		"catering_locations": "Catering locaties",
		"locations": "Locaties",
		"edit": "Prijsaanpassing bewerken",
		"abs": "€",
		"rel": "%",
		"save_changes_success": "Wijzigingen succesvol opgeslagen",
		"save_changes_error": "Er ging iets mis, probeer gelieve later opnieuw te proberen",
		"delete_success": "Prijsaanpassing succesvol verwijderd",
		"delete_error": "Er ging iets mis, gelieve het later opnieuw te proberen",
		"price_min_max_placeholder": "Bijvoorbeeld: -3.50",
		"add_now": "Toevoegen",
		"day": "Dag",
		"start_time": "Starttijd",
		"end_time": "Eindtijd"
	}

}
